<template>
    <div>
        <div class="generated-outfit-info-container" :class="{fullView: showShopItems, 'hide-initial-buttons': hideInitialButtons, 'overflow-visible': isShareModalOpened }" :style="cssProps">
            <transition name="fade">
                <div v-show="shareLoading" class="loading-overlay">
                    <loader></loader>
                </div>
            </transition>
            <div class="swipe-up-container"
                 :class="{hasShare: instagramInstalled }"
                 @touchstart="dragstart"
                 @touchend="dragend">
                <div class="info-buttons">
                    <div class="wtw-container full text-center">
                        <share-outfit
                            :outfit="outfitCurrent"
                            classes="trash"
                            v-show="!hideInitialButtons || showShopItems"
                        />
                        <a v-if="!showShopItems"
                            v-show="!hideInitialButtons"
                           @click="shopItems"
                           class="button gray half-button">
                            Shop Items
                        </a>
                        <a v-else
                           @click="shopItems"
                           class="button gray half-button back-button">
                            Back
                        </a>
                        <purchase-outfit-button
                            v-show="!hideInitialButtons || showShopItems"
                            classes="button pink half-button"
                            :outfit="outfitCurrent"
                        />
                    </div>
                </div>
            </div>
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="blur-svg">
                <defs>
                    <filter id="blur-filter">
                        <feGaussianBlur stdDeviation="20"></feGaussianBlur>
                    </filter>
                </defs>
            </svg>
            <div class="generated-outfit-items-container"
            :class="{ blur: showSwapProduct }">
                <div class="wtw-container" v-if="outfitCurrent">
                    <transition-group name="generated-outfit">
                        <div class="generated-outfit-item"
                             v-for="(product) in outfitCurrent.products" :key="product.product_id">
                            <div class="outfit-item-image"
                                 @click.stop="() => handleItemImageClick(product)"
                                 :style="{ backgroundImage: 'url(' + product.product_image_url + ')' }">

                                <!-- ICONS FOR INDIVIDUAL PRODUCTS -->
                                <div class="icons-container">
                                    <span class="icon">
                                         <save-product :product="product"
                                                       :saveProductClassList="saveProductClassList"
                                                       :outfitId="outfitCurrent.outfit_id">
                                         </save-product>
                                    </span>
                                    <span class="icon" @click.stop="removeProductFromOutfit(product)" v-if="isGeneratedOutfit">
                                        <img class="trash" :src="imageUrl('trash.svg')"/>
                                    </span>
                                    <span class="icon"
                                          @click.stop="$emit('swap-product', product, outfitCurrent)" v-if="!isSavedOutfit">
                                        <img class="swap" :src="imageUrl('swap.svg')"/>
                                    </span>
                                </div>

                            </div>
                            <div class="outfit-info">
                                <div v-if="product.product_brand_title" class="item-brand">
                                    {{ product.product_brand_title }}
                                </div>
                                <div class="item-name" :class="{ noBrand: !product.product_brand_title }">
                                    {{ product.product_title }}
                                </div>
                                <div class="item-price">{{ product.product_price | currency }}</div>
                            </div>
                        </div>
                    </transition-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapGetters} from 'vuex';
    import HeartAnimated from "../common/heart-animated.vue";
    import HeartUnfilled from "../common/heart-unfilled.vue";
    import SaveProduct from "../products/save-product.vue";
    import ShareOutfit from '../outfit/share-outfit.vue';
    import PurchaseOutfitButton from '../outfit/purchase-outfit-button.vue';

    import Loader from "../common/loader.vue";

    import { OUTFIT_TYPES } from '../../config.js';
    import Mixins from "../../mixins/mixins";
    import $ from 'webpack-zepto';

    import {_} from "vue-underscore";

    export default {
        mixins: [Mixins],
        data(){
            return {
                saveProductClassList: "favorite",
                heartAnimating: false,
                dragYstart: 0,
                dragThreshold: 50,
                instagramInstalled: true,
            }
        },
        components: {
            HeartAnimated,
            HeartUnfilled,
            SaveProduct,
            Loader,
            ShareOutfit,
            PurchaseOutfitButton,
        },
        props: ['showShopItems', 'outfitCurrent', 'showSwapProduct', 'hideInitialButtons'],
        computed: {
            ...mapGetters({
                shareLoading: 'share/getLoadingStatus',
                isShareModalOpened: 'share/isShareModalOpened',
            }),
            isGeneratedOutfit() {
                return this.outfitCurrent.type === OUTFIT_TYPES.GENERATED;
            },
            isSavedOutfit() {
                return this.outfitCurrent.type === OUTFIT_TYPES.SAVED;
            },
            cssProps(){
                if(this.showShopItems){
                    const windowHeight = $(window).height();
                    let topCalculated = - windowHeight + (this.hideInitialButtons ? 57 : (windowHeight <= 610 ? 192 : 212));
                    if(this.isShareModalOpened) topCalculated -= 64;
                    return {
                        '--ty': topCalculated + 'px'
                    }
                } else {
                    return {
                        '--ty': '0'
                    }
                }
            }
        },
        methods: {
            dragstart(ev){
                this.dragYstart = ev.touches[0].pageY;
            },
            dragend(ev){
                if (this.dragYstart - ev.changedTouches[0].pageY > this.dragThreshold) {
                    this.shopItems();
                }
                this.dragYstart = 0;
            },
            saveOutfit() {
                // Animate the heart
                this.heartAnimating = true;
                let self = this;
                setTimeout(() => {
                    self.heartAnimating = false;
                }, 800);

                this.$parent.$emit('saveOutfit');
            },
            removeProductFromOutfit(product) {
                this.$store.commit({
                    type: "generatedOutfits/removeProductFromOutfitCurrent",
                    product: product
                });
            },
            getOutfitTotal(outfit) {
                // iterate through products in current outfit and sum prices
                if (outfit && outfit.products) {
                    let products = outfit.products;
                    let sum = 0;
                    _.each(products, product => {
                        sum += parseFloat(product.product_price);
                    });
                    return sum;
                } else {
                    return "loading";
                }
            },
            shopItems() {
                this.$parent.$emit('shopItems');
                this.$emit('shop-items');
            },
            handleItemImageClick(product) {
                this.$helpers.visitProduct(
                    this.$router,
                    product,
                    {
                        outfitId: this.outfitCurrent.outfit_id,
                        outfitType: this.outfitCurrent.type,
                    }
                );
            }
        },
        watch: {
            showShopItems(value) {
                if(value) {
                    document.getElementById('main-wrapper').classList.remove('allow-scrolling');
                } else {
                    document.getElementById('main-wrapper').classList.add('allow-scrolling');
                }
            }
        }
    }

</script>

<style lang="scss" scoped>
    .generated-outfit-info-container {
        &.hide-initial-buttons {
            top: 100%;
            @media (max-height: 610px) {
                top: 100%;
            }
        }
    }
</style>